import { Type, type Static } from '@sinclair/typebox';

/**
 * Paiement capturable après un « client non présenté » (empreinte bancaire ou carte enregistrée,
 * encore autorisée) : le front propose la capture EXISTANTE (`POST /app/pro-payment/:id/capture`),
 * jamais automatique — c'est une décision du pro.
 */
export const NoShowCaptureHintSchema = Type.Object({
  pro_payment_id: Type.Number(),
  payment_type: Type.String({ description: 'ProPaymentType du paiement (BANK_IMPRINT ou CARD_SAVE)' }),
  status: Type.String({ description: 'ProPaymentStatus du paiement (AUTHORIZED ou CANCELLED carte conservée)' }),
});
export type NoShowCaptureHintObject = Static<typeof NoShowCaptureHintSchema>;

export const NoShowResponseSchema = Type.Object({
  message: Type.String(),
  /** Réservation qui porte le marquage : la réservation entière, ou le miroir d'une occurrence de série détachée. */
  reservation_id: Type.Number(),
  no_show_at: Type.String({ format: 'date-time' }),
  no_show_at_formatted: Type.Optional(
    Type.String({ format: 'date-time', meta: { source_key: 'no_show_at', with_time: true } }),
  ),
  /** Absent quand aucun paiement n'est capturable. */
  capture_hint: Type.Optional(NoShowCaptureHintSchema),
});
export type NoShowResponseObject = Static<typeof NoShowResponseSchema>;
